import { render, staticRenderFns } from "./PersonCreate.view.vue?vue&type=template&id=142e3d92"
import script from "./PersonCreate.view.vue?vue&type=script&lang=js"
export * from "./PersonCreate.view.vue?vue&type=script&lang=js"
import style0 from "./PersonCreate.view.vue?vue&type=style&index=0&id=142e3d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports